<template>
  <div class="information">
    <AppDescription v-bind="options" />

    <template v-if="photos.length > 0">
      <p class="information__gallery-title h4">Добавленные фотографии</p>

      <div class="gallery">
        <AppGalleryItem
          v-for="(photo, index) of photos"
          :key="index"
          :photo="photo"
          canOpen
          class="gallery__item"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { parseToPhone } from '@/utils/functions'

import AppDescription from '@/components/AppDescription'
import AppGalleryItem from '@/components/AppGalleryItem'

export default {
  name: 'AppInformation',
  components: {
    AppGalleryItem,
    AppDescription
  },
  data () {
    return {
      options: {
        address: null,
        price: null,
        rating: null,
        telephone: null,
        coating: null,
        fieldSize: null,
        balls: null,
        showers: null,
        changingRooms: null,
        manishki: null,
        lighting: null,
        studdedCleats: null,
        paymentTransfer: null,
        current: null
      },
      photos: []
    }
  },
  async created () {
    await this.fetchData()
    await this.fetchPhotos()
  },
  methods: {
    async fetchData () {
      try {
        const { data } = await this.$api.field.field(this.$route.params.id)

        this.options.address = data?.address
        this.options.price = data?.price
        this.options.rating = data?.rating
        this.options.telephone = parseToPhone(data?.phone)
        this.options.coating = data?.coating
        this.options.fieldSize = data?.fieldSize
        this.options.balls = data?.ball
        this.options.showers = data?.shower
        this.options.changingRooms = data?.changingRooms
        this.options.manishki = data?.manishki
        this.options.lighting = data?.lighting
        this.options.studdedCleats = data?.studdedCleats
        this.options.paymentTransfer = data?.paymentByTransfer
        this.options.schedule = data?.schedule
        this.options.current = data?.scheduleCurrentDayWeek
      } catch (e) {
        console.log(e)
      }
    },
    async fetchPhotos () {
      try {
        const { data } = await this.$api.field.photos(this.$route.params.id)
        const list = data?.list ?? []

        this.photos = list.map(item => item.url)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  &__gallery-title {
    margin: 60px 0 20px;
  }

  .gallery {
    display: flex;
    flex-wrap: wrap;

    &__item {
      width: 145px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
